import { HeroWall } from "@/components/HeroWall";
import { StoryBook } from "@/components/StoryBook";
import { QuoteSection } from "@/components/QuoteSection";

export default function HomePage() {
  return (
    <>
      <HeroWall />
      <StoryBook />
      <QuoteSection />
    </>
  );
}
